import { SxProps, Theme } from "@mui/material";

export const root: SxProps<Theme> = (theme) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  width: "100%",
});
